export default __webpack_public_path__ + "static/media/meter-display.e1c9e3fe.svg";